// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #05060c;
  --panel: rgba(15, 17, 32, 0.92);
  --panel-deep: rgba(8, 9, 18, 0.94);
  --cyan: #2fe0ff;
  --cyan-soft: #7df0ff;
  --purple: #a06bff;
  --purple-deep: #7c3aed;
  --blue: #4f7cff;
  --text: #f0f3ff;
  --body-text: #b8bfd9;
  --muted: #7e86a6;
  --divider: rgba(148, 158, 200, 0.16);
  --input-bg: rgba(8, 10, 20, 0.65);
  --input-border: rgba(148, 158, 200, 0.24);
  --star-empty: #454c6e;
  --danger: #ff6b8a;
  --focus-ring: rgba(47, 224, 255, 0.28);

  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: var(--text);
  color-scheme: dark;
}

body {
  margin: 0;
  background:
    radial-gradient(120vmax 80vmax at 0% 0%, rgba(124, 58, 237, 0.14), transparent 55%),
    radial-gradient(120vmax 80vmax at 100% 100%, rgba(47, 224, 255, 0.1), transparent 55%),
    var(--bg);
  min-height: 100vh;
  color: var(--text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
}

::selection {
  background: rgba(47, 224, 255, 0.32);
  color: var(--text);
}

.app-shell {
  min-height: 100vh;
  padding: 48px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
}

/* Neon backdrop — diagonal light beams and halftone dot fields in the
   top-left and bottom-right corners, echoing the brand key art. */
.backdrop {
  position: fixed;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.backdrop__corner {
  position: absolute;
  width: 78vmin;
  height: 78vmin;
}

.backdrop__corner--tl {
  top: -10vmin;
  left: -10vmin;
}

.backdrop__corner--br {
  bottom: -10vmin;
  right: -10vmin;
  transform: rotate(180deg);
}

.beam {
  position: absolute;
  display: block;
  left: -30%;
  width: 160%;
  border-radius: 999px;
  transform: rotate(-45deg);
}

.beam--glow {
  top: 34%;
  height: 10vmin;
  background: linear-gradient(
    90deg,
    transparent 4%,
    rgba(124, 58, 237, 0.5) 34%,
    rgba(47, 224, 255, 0.32) 62%,
    transparent 96%
  );
  filter: blur(38px);
  opacity: 0.55;
}

.beam--purple {
  top: 30%;
  height: 4px;
  background: linear-gradient(
    90deg,
    transparent 8%,
    rgba(160, 107, 255, 0.95) 42%,
    rgba(124, 58, 237, 0.9) 62%,
    transparent 92%
  );
  box-shadow: 0 0 12px rgba(160, 107, 255, 0.8), 0 0 34px rgba(124, 58, 237, 0.5);
  animation: beam-pulse 9s ease-in-out infinite;
}

.beam--cyan {
  top: 45%;
  height: 3px;
  background: linear-gradient(90deg, transparent 10%, rgba(47, 224, 255, 0.95) 50%, transparent 90%);
  box-shadow: 0 0 10px rgba(47, 224, 255, 0.85), 0 0 30px rgba(47, 224, 255, 0.45);
  animation: beam-pulse 7s ease-in-out 1.5s infinite;
}

.beam--blue {
  top: 56%;
  height: 2px;
  opacity: 0.55;
  background: linear-gradient(90deg, transparent 12%, rgba(79, 124, 255, 0.85) 50%, transparent 88%);
  box-shadow: 0 0 8px rgba(79, 124, 255, 0.6);
}

.beam--hairline {
  top: 21%;
  height: 1px;
  opacity: 0.42;
  background: linear-gradient(90deg, transparent 14%, rgba(125, 240, 255, 0.9) 50%, transparent 86%);
}

.beam--hairline-2 {
  top: 66%;
  height: 1px;
  opacity: 0.28;
  background: linear-gradient(90deg, transparent 14%, rgba(160, 107, 255, 0.9) 50%, transparent 86%);
}

.dots {
  position: absolute;
  top: 0;
  left: 4%;
  width: 92%;
  height: 36%;
  transform: rotate(-45deg);
  background-image:
    radial-gradient(circle, rgba(125, 240, 255, 0.65) 1px, transparent 1.6px),
    radial-gradient(circle, rgba(160, 107, 255, 0.55) 1px, transparent 1.6px);
  background-size: 14px 14px, 23px 23px;
  background-position: 0 0, 8px 11px;
  -webkit-mask-image: radial-gradient(ellipse 62% 95% at 50% 50%, #000 22%, transparent 76%);
  mask-image: radial-gradient(ellipse 62% 95% at 50% 50%, #000 22%, transparent 76%);
  opacity: 0.8;
}

.trace {
  position: absolute;
  top: 10%;
  left: 44%;
  width: 44%;
  height: 44%;
  opacity: 0.5;
}

.trace path {
  fill: none;
  stroke: rgba(79, 124, 255, 0.55);
  stroke-width: 1;
  vector-effect: non-scaling-stroke;
}

@keyframes beam-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.65;
  }
}

@media (prefers-reduced-motion: reduce) {
  .beam--purple,
  .beam--cyan {
    animation: none;
  }
}

.experience-card {
  position: relative;
  z-index: 1;
  width: min(680px, 100%);
  background:
    linear-gradient(165deg, var(--panel), var(--panel-deep)) padding-box,
    linear-gradient(
        135deg,
        rgba(47, 224, 255, 0.55),
        rgba(124, 58, 237, 0.6) 45%,
        rgba(47, 224, 255, 0.22)
      )
      border-box;
  border: 1px solid transparent;
  border-radius: 16px;
  padding: clamp(28px, 4vw, 48px);
  box-shadow:
    0 0 44px rgba(124, 58, 237, 0.14),
    0 0 24px rgba(47, 224, 255, 0.08),
    0 24px 80px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

/* logo-b.svg renders artwork slightly past its intrinsic box, so the wrapper
   provides breathing room and a mild overscale reveals the clipped edges.
   The filter re-plates the mark in white for the dark theme. */
.logo-wrap {
  display: flex;
  justify-content: center;
  margin: 0 auto 40px;
  max-width: 280px;
  overflow: visible;
}

.logo {
  display: block;
  height: auto;
  width: 100%;
  max-height: 64px;
  max-width: 280px;
  margin: 0;
  transform: scale(0.95);
  transform-origin: center;
  filter: brightness(0) invert(1) drop-shadow(0 0 16px rgba(47, 224, 255, 0.35));
}

/* Step indicator */
.step-indicator {
  list-style: none;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0 0 48px;
  gap: 0;
  border-bottom: 1px solid var(--divider);
}

.step {
  display: inline-flex;
  align-items: baseline;
  gap: 10px;
  padding: 14px 22px;
  color: var(--muted);
  font-family: 'Inter', sans-serif;
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.25s ease, border-color 0.25s ease, opacity 0.25s ease;
}

.step__index {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 1rem;
  letter-spacing: 0;
  color: var(--muted);
  font-weight: 600;
}

.step__label {
  font-weight: 600;
}

.step--active {
  color: var(--cyan);
  border-bottom-color: var(--cyan);
  text-shadow: 0 0 18px rgba(47, 224, 255, 0.5);
}

.step--active .step__index {
  color: var(--cyan);
}

.step--complete {
  color: var(--purple);
}

.step--complete .step__index {
  color: var(--purple);
}

.step--dimmed {
  opacity: 0.35;
}

/* Panel */
.panel {
  text-align: center;
}

.eyebrow {
  font-family: 'Inter', sans-serif;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--cyan);
  text-shadow: 0 0 20px rgba(47, 224, 255, 0.45);
  margin: 0 0 14px;
}

h1 {
  font-family: 'Space Grotesk', 'Inter', sans-serif;
  margin: 0 0 18px;
  font-size: clamp(1.9rem, 4.2vw, 2.7rem);
  font-weight: 600;
  line-height: 1.12;
  letter-spacing: -0.01em;
  color: var(--text);
}

h1 em,
.panel h1 .accent {
  font-style: normal;
  background: linear-gradient(100deg, var(--cyan), var(--purple));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: var(--cyan);
}

.subcopy {
  margin: 0 auto 32px;
  max-width: 560px;
  color: var(--body-text);
  line-height: 1.7;
  font-size: 1rem;
}

/* Stars */
.star-rating {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin: 20px 0 12px;
}

.star {
  width: clamp(48px, 9vw, 60px);
  height: clamp(48px, 9vw, 60px);
  border-radius: 4px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: transform 0.18s ease, color 0.18s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--star-empty);
}

.star svg {
  width: 40px;
  height: 40px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.5;
  stroke-linejoin: round;
  transition: fill 0.2s ease, stroke 0.2s ease, filter 0.2s ease;
}

.star:hover,
.star:focus-visible {
  color: var(--cyan-soft);
  transform: translateY(-2px);
  outline: none;
}

.star:focus-visible {
  box-shadow: 0 0 0 3px var(--bg), 0 0 0 6px var(--focus-ring);
  border-radius: 6px;
}

.star--filled {
  color: var(--cyan);
}

.star--filled svg {
  fill: var(--cyan);
  stroke: var(--cyan);
  filter: drop-shadow(0 0 7px rgba(47, 224, 255, 0.6));
}

.rating-label {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--cyan-soft);
  margin: 16px 0 0;
}

.rating-label--empty {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 0.95rem;
  color: var(--muted);
  letter-spacing: 0.02em;
}

/* Form */
.feedback-form {
  display: grid;
  gap: 20px;
  text-align: left;
  max-width: 560px;
  margin: 0 auto;
}

.feedback-form label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--body-text);
}

.feedback-form input,
.feedback-form textarea {
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 1rem;
  font-family: 'Inter', sans-serif;
  letter-spacing: 0;
  text-transform: none;
  color: var(--text);
  font-weight: 400;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.feedback-form input::placeholder,
.feedback-form textarea::placeholder {
  color: var(--muted);
  opacity: 0.8;
}

.feedback-form input:focus,
.feedback-form textarea:focus {
  outline: none;
  border-color: var(--cyan);
  box-shadow: 0 0 0 3px var(--focus-ring), 0 0 18px rgba(47, 224, 255, 0.12);
}

.feedback-form textarea {
  resize: vertical;
  min-height: 96px;
}

/* Buttons */
button,
.feedback-form button,
.review-actions a {
  font-family: 'Inter', sans-serif;
}

.primary,
.secondary,
.ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 14px 28px;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: none;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease,
    transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
  border: 1px solid transparent;
}

.primary {
  background: linear-gradient(100deg, #14b8dc 0%, var(--purple-deep) 100%);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow:
    0 0 18px rgba(47, 224, 255, 0.22),
    0 0 34px rgba(124, 58, 237, 0.24),
    0 8px 24px rgba(0, 0, 0, 0.45);
}

.primary:hover,
.primary:focus-visible {
  outline: none;
  transform: translateY(-1px);
  filter: brightness(1.12);
  box-shadow:
    0 0 24px rgba(47, 224, 255, 0.35),
    0 0 44px rgba(124, 58, 237, 0.35),
    0 10px 28px rgba(0, 0, 0, 0.5);
}

.primary:focus-visible {
  box-shadow:
    0 0 0 3px var(--focus-ring),
    0 0 24px rgba(47, 224, 255, 0.35),
    0 0 44px rgba(124, 58, 237, 0.35);
}

.primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  filter: none;
  box-shadow: none;
}

.secondary {
  background: transparent;
  color: var(--cyan);
  border-color: rgba(47, 224, 255, 0.55);
}

.secondary:hover,
.secondary:focus-visible {
  background: rgba(47, 224, 255, 0.12);
  color: var(--cyan-soft);
  border-color: var(--cyan);
  outline: none;
  transform: translateY(-1px);
  box-shadow: 0 0 20px rgba(47, 224, 255, 0.25);
}

.secondary:focus-visible {
  box-shadow: 0 0 0 3px var(--focus-ring);
}

.ghost {
  background: transparent;
  color: var(--body-text);
  border-color: var(--divider);
}

.ghost:hover,
.ghost:focus-visible {
  border-color: rgba(160, 107, 255, 0.6);
  color: var(--text);
  outline: none;
  box-shadow: 0 0 16px rgba(160, 107, 255, 0.18);
}

.ghost:focus-visible {
  box-shadow: 0 0 0 3px var(--focus-ring);
}

.full-width {
  width: 100%;
}

.review-actions {
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: stretch;
  max-width: 560px;
  margin: 0 auto;
}

.cta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-top: 8px;
}

.error-text {
  color: var(--danger);
  margin: 0;
  font-size: 0.9rem;
}

.optional-tag,
.required-tag {
  font-weight: 400;
  font-size: 0.75em;
  letter-spacing: 0.12em;
  text-transform: none;
}

.optional-tag {
  color: var(--muted);
  opacity: 0.85;
}

.required-tag {
  color: var(--cyan);
  opacity: 0.9;
}

.field-error {
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  color: var(--danger);
  margin-top: 4px;
}

.feedback-form input[aria-invalid='true'],
.feedback-form textarea[aria-invalid='true'] {
  border-color: var(--danger);
  box-shadow: 0 0 0 3px rgba(255, 107, 138, 0.16);
}

.review-preview {
  background: rgba(124, 58, 237, 0.1);
  border: 1px solid rgba(160, 107, 255, 0.22);
  border-left: 2px solid var(--cyan);
  border-radius: 0 8px 8px 0;
  padding: 22px 28px;
  margin: 0 auto 24px;
  max-width: 560px;
  text-align: left;
}

.review-preview__text {
  margin: 0;
  font-style: italic;
  font-size: 1.08rem;
  color: var(--text);
  line-height: 1.6;
}

.hint-text {
  font-size: 0.88rem;
  color: var(--muted);
  margin: 0;
}

.paste-guide {
  background: rgba(47, 224, 255, 0.06);
  border: 1px solid rgba(47, 224, 255, 0.22);
  border-radius: 8px;
  padding: 16px 20px;
  text-align: left;
}

.paste-guide__step {
  margin: 0 0 8px;
  font-weight: 600;
  color: var(--text);
  font-size: 0.92rem;
}

.paste-guide__shortcut {
  margin: 0;
  color: var(--body-text);
  font-size: 0.88rem;
}

.paste-guide__shortcut kbd {
  background: rgba(8, 10, 20, 0.85);
  border: 1px solid rgba(148, 158, 200, 0.3);
  border-radius: 5px;
  padding: 2px 8px;
  font-family: 'Inter', sans-serif;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--cyan-soft);
}

.copy-fallback {
  background: rgba(255, 107, 138, 0.07);
  border: 1px solid rgba(255, 107, 138, 0.3);
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: left;
}

.copy-fallback__label {
  margin: 0;
  font-weight: 600;
  color: var(--danger);
  font-size: 0.88rem;
}

.copy-fallback__text {
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 0.95rem;
  color: var(--text);
  font-family: 'Inter', sans-serif;
  resize: none;
  width: 100%;
}

/* Mobile */
@media (max-width: 640px) {
  .app-shell {
    padding: 24px 14px;
  }

  .experience-card {
    padding: 28px 20px;
  }

  .step-indicator {
    overflow-x: auto;
    justify-content: flex-start;
  }

  .step {
    padding: 12px 14px;
    font-size: 0.68rem;
    letter-spacing: 0.18em;
    white-space: nowrap;
  }

  .star-rating {
    gap: 8px;
  }

  .logo-wrap {
    margin-bottom: 28px;
  }

  .logo {
    max-height: 48px;
    max-width: 220px;
  }

  .cta-grid {
    grid-template-columns: 1fr;
  }

  .backdrop__corner {
    width: 96vmin;
    height: 96vmin;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,oCAAoC;EACpC,iCAAiC;EACjC,yCAAyC;EACzC,qBAAqB;EACrB,iBAAiB;EACjB,sCAAsC;;EAEtC,0FAA0F;EAC1F,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT;;;aAGW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;kEACkE;AAClE;EACE,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,cAAc;EACd;;;;;;GAMC;EACD,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,WAAW;EACX;;;;;;GAMC;EACD,+EAA+E;EAC/E,6CAA6C;AAC/C;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,kGAAkG;EAClG,gFAAgF;EAChF,kDAAkD;AACpD;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,aAAa;EACb,kGAAkG;EAClG,2CAA2C;AAC7C;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,aAAa;EACb,kGAAkG;AACpG;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,aAAa;EACb,kGAAkG;AACpG;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB;;6EAE2E;EAC3E,qCAAqC;EACrC,kCAAkC;EAClC,0FAA0F;EAC1F,kFAAkF;EAClF,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB;;;;;;;;gBAQc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,+BAA+B;EAC/B;;;kCAGgC;EAChC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;;+DAE+D;AAC/D;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,8EAA8E;AAChF;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,MAAM;EACN,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,yEAAyE;AAC3E;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,+DAA+D;EAC/D,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,0EAA0E;AAC5E;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf;gEAC8D;EAC9D,6BAA6B;AAC/B;;AAEA;EACE,wEAAwE;EACxE,cAAc;EACd,uCAAuC;EACvC;;;kCAGgC;AAClC;;AAEA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,wBAAwB;EACxB;;;kCAGgC;AAClC;;AAEA;EACE;;;qCAGmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;EAEE,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,WAAW;AACb;;AAEA,WAAW;AACX;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Inter:wght@400;500;600;700&display=swap');\n\n:root {\n  --bg: #05060c;\n  --panel: rgba(15, 17, 32, 0.92);\n  --panel-deep: rgba(8, 9, 18, 0.94);\n  --cyan: #2fe0ff;\n  --cyan-soft: #7df0ff;\n  --purple: #a06bff;\n  --purple-deep: #7c3aed;\n  --blue: #4f7cff;\n  --text: #f0f3ff;\n  --body-text: #b8bfd9;\n  --muted: #7e86a6;\n  --divider: rgba(148, 158, 200, 0.16);\n  --input-bg: rgba(8, 10, 20, 0.65);\n  --input-border: rgba(148, 158, 200, 0.24);\n  --star-empty: #454c6e;\n  --danger: #ff6b8a;\n  --focus-ring: rgba(47, 224, 255, 0.28);\n\n  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: var(--text);\n  color-scheme: dark;\n}\n\nbody {\n  margin: 0;\n  background:\n    radial-gradient(120vmax 80vmax at 0% 0%, rgba(124, 58, 237, 0.14), transparent 55%),\n    radial-gradient(120vmax 80vmax at 100% 100%, rgba(47, 224, 255, 0.1), transparent 55%),\n    var(--bg);\n  min-height: 100vh;\n  color: var(--text);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n::selection {\n  background: rgba(47, 224, 255, 0.32);\n  color: var(--text);\n}\n\n.app-shell {\n  min-height: 100vh;\n  padding: 48px 20px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  position: relative;\n}\n\n/* Neon backdrop — diagonal light beams and halftone dot fields in the\n   top-left and bottom-right corners, echoing the brand key art. */\n.backdrop {\n  position: fixed;\n  inset: 0;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.backdrop__corner {\n  position: absolute;\n  width: 78vmin;\n  height: 78vmin;\n}\n\n.backdrop__corner--tl {\n  top: -10vmin;\n  left: -10vmin;\n}\n\n.backdrop__corner--br {\n  bottom: -10vmin;\n  right: -10vmin;\n  transform: rotate(180deg);\n}\n\n.beam {\n  position: absolute;\n  display: block;\n  left: -30%;\n  width: 160%;\n  border-radius: 999px;\n  transform: rotate(-45deg);\n}\n\n.beam--glow {\n  top: 34%;\n  height: 10vmin;\n  background: linear-gradient(\n    90deg,\n    transparent 4%,\n    rgba(124, 58, 237, 0.5) 34%,\n    rgba(47, 224, 255, 0.32) 62%,\n    transparent 96%\n  );\n  filter: blur(38px);\n  opacity: 0.55;\n}\n\n.beam--purple {\n  top: 30%;\n  height: 4px;\n  background: linear-gradient(\n    90deg,\n    transparent 8%,\n    rgba(160, 107, 255, 0.95) 42%,\n    rgba(124, 58, 237, 0.9) 62%,\n    transparent 92%\n  );\n  box-shadow: 0 0 12px rgba(160, 107, 255, 0.8), 0 0 34px rgba(124, 58, 237, 0.5);\n  animation: beam-pulse 9s ease-in-out infinite;\n}\n\n.beam--cyan {\n  top: 45%;\n  height: 3px;\n  background: linear-gradient(90deg, transparent 10%, rgba(47, 224, 255, 0.95) 50%, transparent 90%);\n  box-shadow: 0 0 10px rgba(47, 224, 255, 0.85), 0 0 30px rgba(47, 224, 255, 0.45);\n  animation: beam-pulse 7s ease-in-out 1.5s infinite;\n}\n\n.beam--blue {\n  top: 56%;\n  height: 2px;\n  opacity: 0.55;\n  background: linear-gradient(90deg, transparent 12%, rgba(79, 124, 255, 0.85) 50%, transparent 88%);\n  box-shadow: 0 0 8px rgba(79, 124, 255, 0.6);\n}\n\n.beam--hairline {\n  top: 21%;\n  height: 1px;\n  opacity: 0.42;\n  background: linear-gradient(90deg, transparent 14%, rgba(125, 240, 255, 0.9) 50%, transparent 86%);\n}\n\n.beam--hairline-2 {\n  top: 66%;\n  height: 1px;\n  opacity: 0.28;\n  background: linear-gradient(90deg, transparent 14%, rgba(160, 107, 255, 0.9) 50%, transparent 86%);\n}\n\n.dots {\n  position: absolute;\n  top: 0;\n  left: 4%;\n  width: 92%;\n  height: 36%;\n  transform: rotate(-45deg);\n  background-image:\n    radial-gradient(circle, rgba(125, 240, 255, 0.65) 1px, transparent 1.6px),\n    radial-gradient(circle, rgba(160, 107, 255, 0.55) 1px, transparent 1.6px);\n  background-size: 14px 14px, 23px 23px;\n  background-position: 0 0, 8px 11px;\n  -webkit-mask-image: radial-gradient(ellipse 62% 95% at 50% 50%, #000 22%, transparent 76%);\n  mask-image: radial-gradient(ellipse 62% 95% at 50% 50%, #000 22%, transparent 76%);\n  opacity: 0.8;\n}\n\n.trace {\n  position: absolute;\n  top: 10%;\n  left: 44%;\n  width: 44%;\n  height: 44%;\n  opacity: 0.5;\n}\n\n.trace path {\n  fill: none;\n  stroke: rgba(79, 124, 255, 0.55);\n  stroke-width: 1;\n  vector-effect: non-scaling-stroke;\n}\n\n@keyframes beam-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.65;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .beam--purple,\n  .beam--cyan {\n    animation: none;\n  }\n}\n\n.experience-card {\n  position: relative;\n  z-index: 1;\n  width: min(680px, 100%);\n  background:\n    linear-gradient(165deg, var(--panel), var(--panel-deep)) padding-box,\n    linear-gradient(\n        135deg,\n        rgba(47, 224, 255, 0.55),\n        rgba(124, 58, 237, 0.6) 45%,\n        rgba(47, 224, 255, 0.22)\n      )\n      border-box;\n  border: 1px solid transparent;\n  border-radius: 16px;\n  padding: clamp(28px, 4vw, 48px);\n  box-shadow:\n    0 0 44px rgba(124, 58, 237, 0.14),\n    0 0 24px rgba(47, 224, 255, 0.08),\n    0 24px 80px rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n/* logo-b.svg renders artwork slightly past its intrinsic box, so the wrapper\n   provides breathing room and a mild overscale reveals the clipped edges.\n   The filter re-plates the mark in white for the dark theme. */\n.logo-wrap {\n  display: flex;\n  justify-content: center;\n  margin: 0 auto 40px;\n  max-width: 280px;\n  overflow: visible;\n}\n\n.logo {\n  display: block;\n  height: auto;\n  width: 100%;\n  max-height: 64px;\n  max-width: 280px;\n  margin: 0;\n  transform: scale(0.95);\n  transform-origin: center;\n  filter: brightness(0) invert(1) drop-shadow(0 0 16px rgba(47, 224, 255, 0.35));\n}\n\n/* Step indicator */\n.step-indicator {\n  list-style: none;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin: 0 0 48px;\n  gap: 0;\n  border-bottom: 1px solid var(--divider);\n}\n\n.step {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 10px;\n  padding: 14px 22px;\n  color: var(--muted);\n  font-family: 'Inter', sans-serif;\n  font-size: 0.72rem;\n  font-weight: 500;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: color 0.25s ease, border-color 0.25s ease, opacity 0.25s ease;\n}\n\n.step__index {\n  font-family: 'Space Grotesk', sans-serif;\n  font-size: 1rem;\n  letter-spacing: 0;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n.step__label {\n  font-weight: 600;\n}\n\n.step--active {\n  color: var(--cyan);\n  border-bottom-color: var(--cyan);\n  text-shadow: 0 0 18px rgba(47, 224, 255, 0.5);\n}\n\n.step--active .step__index {\n  color: var(--cyan);\n}\n\n.step--complete {\n  color: var(--purple);\n}\n\n.step--complete .step__index {\n  color: var(--purple);\n}\n\n.step--dimmed {\n  opacity: 0.35;\n}\n\n/* Panel */\n.panel {\n  text-align: center;\n}\n\n.eyebrow {\n  font-family: 'Inter', sans-serif;\n  letter-spacing: 0.24em;\n  text-transform: uppercase;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--cyan);\n  text-shadow: 0 0 20px rgba(47, 224, 255, 0.45);\n  margin: 0 0 14px;\n}\n\nh1 {\n  font-family: 'Space Grotesk', 'Inter', sans-serif;\n  margin: 0 0 18px;\n  font-size: clamp(1.9rem, 4.2vw, 2.7rem);\n  font-weight: 600;\n  line-height: 1.12;\n  letter-spacing: -0.01em;\n  color: var(--text);\n}\n\nh1 em,\n.panel h1 .accent {\n  font-style: normal;\n  background: linear-gradient(100deg, var(--cyan), var(--purple));\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: var(--cyan);\n}\n\n.subcopy {\n  margin: 0 auto 32px;\n  max-width: 560px;\n  color: var(--body-text);\n  line-height: 1.7;\n  font-size: 1rem;\n}\n\n/* Stars */\n.star-rating {\n  display: flex;\n  justify-content: center;\n  gap: 14px;\n  margin: 20px 0 12px;\n}\n\n.star {\n  width: clamp(48px, 9vw, 60px);\n  height: clamp(48px, 9vw, 60px);\n  border-radius: 4px;\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  transition: transform 0.18s ease, color 0.18s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--star-empty);\n}\n\n.star svg {\n  width: 40px;\n  height: 40px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.5;\n  stroke-linejoin: round;\n  transition: fill 0.2s ease, stroke 0.2s ease, filter 0.2s ease;\n}\n\n.star:hover,\n.star:focus-visible {\n  color: var(--cyan-soft);\n  transform: translateY(-2px);\n  outline: none;\n}\n\n.star:focus-visible {\n  box-shadow: 0 0 0 3px var(--bg), 0 0 0 6px var(--focus-ring);\n  border-radius: 6px;\n}\n\n.star--filled {\n  color: var(--cyan);\n}\n\n.star--filled svg {\n  fill: var(--cyan);\n  stroke: var(--cyan);\n  filter: drop-shadow(0 0 7px rgba(47, 224, 255, 0.6));\n}\n\n.rating-label {\n  font-family: 'Space Grotesk', sans-serif;\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: var(--cyan-soft);\n  margin: 16px 0 0;\n}\n\n.rating-label--empty {\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n  font-size: 0.95rem;\n  color: var(--muted);\n  letter-spacing: 0.02em;\n}\n\n/* Form */\n.feedback-form {\n  display: grid;\n  gap: 20px;\n  text-align: left;\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.feedback-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-family: 'Inter', sans-serif;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: var(--body-text);\n}\n\n.feedback-form input,\n.feedback-form textarea {\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: 8px;\n  padding: 14px 16px;\n  font-size: 1rem;\n  font-family: 'Inter', sans-serif;\n  letter-spacing: 0;\n  text-transform: none;\n  color: var(--text);\n  font-weight: 400;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.feedback-form input::placeholder,\n.feedback-form textarea::placeholder {\n  color: var(--muted);\n  opacity: 0.8;\n}\n\n.feedback-form input:focus,\n.feedback-form textarea:focus {\n  outline: none;\n  border-color: var(--cyan);\n  box-shadow: 0 0 0 3px var(--focus-ring), 0 0 18px rgba(47, 224, 255, 0.12);\n}\n\n.feedback-form textarea {\n  resize: vertical;\n  min-height: 96px;\n}\n\n/* Buttons */\nbutton,\n.feedback-form button,\n.review-actions a {\n  font-family: 'Inter', sans-serif;\n}\n\n.primary,\n.secondary,\n.ghost {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  padding: 14px 28px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease,\n    transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;\n  border: 1px solid transparent;\n}\n\n.primary {\n  background: linear-gradient(100deg, #14b8dc 0%, var(--purple-deep) 100%);\n  color: #ffffff;\n  border-color: rgba(255, 255, 255, 0.12);\n  box-shadow:\n    0 0 18px rgba(47, 224, 255, 0.22),\n    0 0 34px rgba(124, 58, 237, 0.24),\n    0 8px 24px rgba(0, 0, 0, 0.45);\n}\n\n.primary:hover,\n.primary:focus-visible {\n  outline: none;\n  transform: translateY(-1px);\n  filter: brightness(1.12);\n  box-shadow:\n    0 0 24px rgba(47, 224, 255, 0.35),\n    0 0 44px rgba(124, 58, 237, 0.35),\n    0 10px 28px rgba(0, 0, 0, 0.5);\n}\n\n.primary:focus-visible {\n  box-shadow:\n    0 0 0 3px var(--focus-ring),\n    0 0 24px rgba(47, 224, 255, 0.35),\n    0 0 44px rgba(124, 58, 237, 0.35);\n}\n\n.primary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n  filter: none;\n  box-shadow: none;\n}\n\n.secondary {\n  background: transparent;\n  color: var(--cyan);\n  border-color: rgba(47, 224, 255, 0.55);\n}\n\n.secondary:hover,\n.secondary:focus-visible {\n  background: rgba(47, 224, 255, 0.12);\n  color: var(--cyan-soft);\n  border-color: var(--cyan);\n  outline: none;\n  transform: translateY(-1px);\n  box-shadow: 0 0 20px rgba(47, 224, 255, 0.25);\n}\n\n.secondary:focus-visible {\n  box-shadow: 0 0 0 3px var(--focus-ring);\n}\n\n.ghost {\n  background: transparent;\n  color: var(--body-text);\n  border-color: var(--divider);\n}\n\n.ghost:hover,\n.ghost:focus-visible {\n  border-color: rgba(160, 107, 255, 0.6);\n  color: var(--text);\n  outline: none;\n  box-shadow: 0 0 16px rgba(160, 107, 255, 0.18);\n}\n\n.ghost:focus-visible {\n  box-shadow: 0 0 0 3px var(--focus-ring);\n}\n\n.full-width {\n  width: 100%;\n}\n\n.review-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  align-items: stretch;\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.cta-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.error-text {\n  color: var(--danger);\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.optional-tag,\n.required-tag {\n  font-weight: 400;\n  font-size: 0.75em;\n  letter-spacing: 0.12em;\n  text-transform: none;\n}\n\n.optional-tag {\n  color: var(--muted);\n  opacity: 0.85;\n}\n\n.required-tag {\n  color: var(--cyan);\n  opacity: 0.9;\n}\n\n.field-error {\n  font-family: 'Inter', sans-serif;\n  font-size: 0.82rem;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-transform: none;\n  color: var(--danger);\n  margin-top: 4px;\n}\n\n.feedback-form input[aria-invalid='true'],\n.feedback-form textarea[aria-invalid='true'] {\n  border-color: var(--danger);\n  box-shadow: 0 0 0 3px rgba(255, 107, 138, 0.16);\n}\n\n.review-preview {\n  background: rgba(124, 58, 237, 0.1);\n  border: 1px solid rgba(160, 107, 255, 0.22);\n  border-left: 2px solid var(--cyan);\n  border-radius: 0 8px 8px 0;\n  padding: 22px 28px;\n  margin: 0 auto 24px;\n  max-width: 560px;\n  text-align: left;\n}\n\n.review-preview__text {\n  margin: 0;\n  font-style: italic;\n  font-size: 1.08rem;\n  color: var(--text);\n  line-height: 1.6;\n}\n\n.hint-text {\n  font-size: 0.88rem;\n  color: var(--muted);\n  margin: 0;\n}\n\n.paste-guide {\n  background: rgba(47, 224, 255, 0.06);\n  border: 1px solid rgba(47, 224, 255, 0.22);\n  border-radius: 8px;\n  padding: 16px 20px;\n  text-align: left;\n}\n\n.paste-guide__step {\n  margin: 0 0 8px;\n  font-weight: 600;\n  color: var(--text);\n  font-size: 0.92rem;\n}\n\n.paste-guide__shortcut {\n  margin: 0;\n  color: var(--body-text);\n  font-size: 0.88rem;\n}\n\n.paste-guide__shortcut kbd {\n  background: rgba(8, 10, 20, 0.85);\n  border: 1px solid rgba(148, 158, 200, 0.3);\n  border-radius: 5px;\n  padding: 2px 8px;\n  font-family: 'Inter', sans-serif;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--cyan-soft);\n}\n\n.copy-fallback {\n  background: rgba(255, 107, 138, 0.07);\n  border: 1px solid rgba(255, 107, 138, 0.3);\n  border-radius: 8px;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  text-align: left;\n}\n\n.copy-fallback__label {\n  margin: 0;\n  font-weight: 600;\n  color: var(--danger);\n  font-size: 0.88rem;\n}\n\n.copy-fallback__text {\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: 8px;\n  padding: 12px 14px;\n  font-size: 0.95rem;\n  color: var(--text);\n  font-family: 'Inter', sans-serif;\n  resize: none;\n  width: 100%;\n}\n\n/* Mobile */\n@media (max-width: 640px) {\n  .app-shell {\n    padding: 24px 14px;\n  }\n\n  .experience-card {\n    padding: 28px 20px;\n  }\n\n  .step-indicator {\n    overflow-x: auto;\n    justify-content: flex-start;\n  }\n\n  .step {\n    padding: 12px 14px;\n    font-size: 0.68rem;\n    letter-spacing: 0.18em;\n    white-space: nowrap;\n  }\n\n  .star-rating {\n    gap: 8px;\n  }\n\n  .logo-wrap {\n    margin-bottom: 28px;\n  }\n\n  .logo {\n    max-height: 48px;\n    max-width: 220px;\n  }\n\n  .cta-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .backdrop__corner {\n    width: 96vmin;\n    height: 96vmin;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
